import React, { useState } from "react";

const MARK_BG = "#F7FAFF";

export default function BrandMark({
  sizeClass = "w-11 h-11",
  className = "",
  style = {},
}) {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className={`${sizeClass} shrink-0 rounded-full overflow-hidden ${className}`.trim()}
      style={{
        background: MARK_BG,
        boxShadow: "0 4px 14px rgba(30, 63, 224, 0.18)",
        ...style,
      }}
      aria-hidden="true"
    >
      {!imgError ? (
        <img
          src="/images/home/birdmascot-badge-256.webp"
          alt="Austuition mascot"
          className="w-full h-full object-cover"
          draggable="false"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="font-heading text-[0.65rem] font-bold text-aus-cobalt leading-none px-1 text-center w-full h-full flex items-center justify-center">
          AU
        </span>
      )}
    </div>
  );
}
